import { render } from "./LisaSuites.vue?vue&type=template&id=074f20cd&scoped=true"
import script from "./LisaSuites.vue?vue&type=script&lang=js"
export * from "./LisaSuites.vue?vue&type=script&lang=js"

import "./LisaSuites.vue?vue&type=style&index=0&id=074f20cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074f20cd"]])

export default __exports__